import { FaStar } from "react-icons/fa";
import { NavLink } from "react-router-dom";


const RecommendCard = ({res}) => {
    const data = res.entry[0];
    return (
        <div className="flex"> 
            <NavLink to="/view" className="m-5 w-56 ">
                <div className="">
                    <img src={data.images.jpg.image_url} alt="" className="z-10 rounded-[12px]" />
                </div>
                <div className="z-100 -mt-[100px] card-holder h-32 bg-gray-800 shadow-black">
                    <div className="flex p-4 font-bold flex-col">
                        
                        <div className="flex flex-col h-full ">
                            <div className="mt-2 text-sm line-clamp-2">
                                {data.title}
                            </div>
                            <div className="md:text-md text-xs flex items-center self-start gap-2 mt-1 rounded-xl bg-gray-700 px-2 ">
                                By {res.user.username}
                            </div>
                        </div>
                    </div>
                </div>
            </NavLink>
            
        </div>
    )
}

export default RecommendCard;